import React from 'react';
import CrudPage from '../../components/CrudPage';
import { forSaleApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'forSaleId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Property ID', field: 'propertyId' },
  { header: 'Shares', field: 'amountTannit' },
  { header: 'Asking Price', field: 'askingPrice', render: (v) => v ? `£${v.toLocaleString()}` : '-' },
  { header: 'Status', field: 'status' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'propertyId', label: 'Property ID', type: 'number', required: true },
  { name: 'amountTannit', label: 'Shares (Tannit)', type: 'number', required: true },
  { name: 'askingPrice', label: 'Asking Price', type: 'number' },
  { name: 'sellingPercentage', label: 'Selling Percentage', type: 'number' },
];

const ForSalePage = () => (
  <CrudPage
    title="For Sale"
    subtitle="Manage marketplace listings"
    api={forSaleApi}
    columns={columns}
    formFields={formFields}
    idField="forSaleId"
    disableEdit={true}
    disableDelete={true}
  />
);

export default ForSalePage;
